import { render, staticRenderFns } from "./LtkDetailHeader.vue?vue&type=template&id=6d3e4ccd"
import script from "./LtkDetailHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkDetailHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkShopAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/Ltk/LtkShopAvatar.vue').default,CreatorShopLink: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/CreatorShopLink.vue').default,CreatorShopCollectionShareButton: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/collection/ShareButton.vue').default})
